import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { UserService } from "../../../api-services/AdminHRService/User/user-service.service";
import { ToasterService } from "../../../services/toaster.service";
import { StorageService } from "../../../guards/StorageService";
import { PermissionService } from "../../../api-services/Permission/permission.service";
import { firstValueFrom } from "rxjs";
import { AuthService } from "../../../api-services/AdminHRService/Login/auth.service";
import { CandidateProfileComponent } from "../candidate-profile/candidate-profile.component";
import { CandidateService } from "../../../api-services/AdminHRService/OnBoardProcess/candidate.service";

@Component({
  selector: 'app-candidate-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './candidate-login.component.html',
  styleUrl: './candidate-login.component.css'
})
export class CandidateLoginComponent implements OnInit {
  loginForm!: FormGroup;
  showPassword = false;
  errorMessage = '';
  successMessage = '';

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private userService: UserService,
    private storageService: StorageService,
    private toasterServive: ToasterService,
    private permissionService: PermissionService,
    private authService: AuthService,
    private readonly candidateProfileService :CandidateService
  ) { }

  ngOnInit(): void {
    console.log('CandidateLoginComponent loaded');
    this.initializeForm();
  }

  private initializeForm(): void {
    this.loginForm = this.formBuilder.group({
      userName: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  get userName() {
    return this.loginForm.get('userName');
  }

  get password() {
    return this.loginForm.get('password');
  }

  // async onSubmit(): Promise<void> {
  //   if (this.loginForm.valid) {
  //     const { userName, password } = this.loginForm.value;

  //     this.userService.verifyCandidate(userName, password).subscribe({
  //       next: async (resp) => {
  //         if (resp.statusCode === 200) {
  //           this.toasterServive.info(resp.message);
  //           this.storageService.setItem('CandidateProfileDetail', resp.data);

  //           const permissionResp = await firstValueFrom(
  //             this.permissionService.loadMyPermissions(resp.data.designationId, resp.data.departmentId)
  //           );

  //           this.router.navigate(['/CandidateProfile']);
  //         }
  //       },
  //       error: (error) => {
  //         this.toasterServive.error(error.error.message);
  //       }
  //     });
  //   } else {
  //     Object.keys(this.loginForm.controls).forEach(key => {
  //       this.loginForm.get(key)?.markAsTouched();
  //     });
  //   }
  // }

  onSubmit(): void {
    if (this.loginForm.valid) {

      const form = this.loginForm.value;

      const payload = {
        emailId: form.userName,
        employeeCode: '',
        password: form.password,
        isEmployee: false
      }

      this.userService.VerifyUser(payload).subscribe({
        next: async (resp) => {
          if (resp.statusCode === 200) {

            this.authService.setAccessToken(resp.data.accessToken);
            this.storageService.setRefreshToken(resp.data.refreshToken);
            this.storageService.setLoginDateTime(new Date().toISOString());
            this.authService.markAuthenticated();

            const verifyDataResp = await firstValueFrom(
              this.candidateProfileService.VerifyCandidateProfileLogin(form.userName, form.password)
            ); 

            this.storageService.setItem('CandidateProfileDetail', verifyDataResp.data);

            const PermissionResp = await firstValueFrom(
              this.permissionService.loadMyPermissions('Candidate')
            )

            this.router.navigate(['/CandidateProfile']);

            this.toasterServive.info(resp.message);
          }
        },
        error: (error) => {
          this.toasterServive.error(error.error.message);
        }
      });
    } else {
      Object.keys(this.loginForm.controls).forEach(key => {
        this.loginForm.get(key)?.markAsTouched();
      });
    }
  }



}